<div class="sticky-header">
    <div class="sticky-header-role">
        <span translate>admin.workflow.visualisation.role</span>
    </div>
    <div *ngIf="showSegmentNamesColumn" class="sticky-header-name">
        <span translate>admin.workflow.visualisation.segment</span>
    </div>
    <div *ngIf="showSegmentNamesColumn" class="sticky-header-name">
        <span translate>admin.workflow.visualisation.notification</span>
    </div>
</div>
